<template>
    <!-- 设置系数  -->
  <el-dialog :visible.sync="setcoefficientDialog" width="420px" title="设置系数" class="addBrand">
    <el-form :model="queryParams">
      <el-row>
        <el-col :span="23">
          <el-form-item label="请设置星级系数：" label-width="120px">
            <el-input v-model="queryParams.starPoint" placeholder="请输入百分比数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <el-form-item>%</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSetStarSubmit">提 交</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { starAdd, starUpdate } from '@/api/customer/customerManage'
export default {
  data () {
    return {
      setcoefficientDialog: false,
      queryParams: {},
      isAddOrEdit: ''// 添加或者是编辑
    }
  },
  methods: {
    // 设置系数初始方法
    onInitial (type, row) {
      this.isAddOrEdit = type
      if (type === 'edit') {
        this.queryParams = JSON.parse(JSON.stringify(row))
        this.queryParams.starPoint = row.starPoint * 100
      } else {
        this.queryParams = {}
      }
      this.setcoefficientDialog = true
    },
    // 提交确认
    onSetStarSubmit () {
      const num = /[^\d+(\d\d\d)*.\d+$]/g
      if (this.queryParams.starPoint === '') {
        this.$message.error('设置系数不能为空')
      } else if (num.test(this.queryParams.starPoint)) {
        this.$message.error('请输入正确的系数')
      } else if (this.isAddOrEdit === 'add') {
        const starPoint = this.queryParams.starPoint / 100
        starAdd(starPoint).then(res => { // 添加
          if (res.data.code === 200) {
            this.$emit('onRefresh')
            this.$message.success('添加成功!')
            this.queryParams = {}
            this.setcoefficientDialog = false
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        const query = JSON.parse(JSON.stringify(this.queryParams))
        query.starPoint = this.queryParams.starPoint / 100
        starUpdate(query).then(res => { // 编辑
          if (res.data.code === 200) {
            this.$emit('onRefresh')
            this.$message.success('编辑成功!')
            this.queryParams = {}
            this.setcoefficientDialog = false
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // 取消
    onClose () {
      this.queryParams = {}
      this.setcoefficientDialog = false
    }
  }
}
</script>
<style lang="sass" scope>

</style>
